



import Vue from "vue";
import LatestCreatedInvoicesTable from "./LatestCreatedInvoicesTable.vue";
export default Vue.extend({
  name: "dashboard",
  components: {
    LatestCreatedInvoicesTable,
  },
});
